import React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import CopyableField from '~/components/Common/CopyableField';

interface Props {
  label: string;
  value?: string;
}

export default function PackageIdentifier({ label, value }: Props) {
  const displayValue = value || 'Not available';

  return (
    <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
      <Typography variant="body2" sx={{ fontWeight: 700 }} color="text.secondary" noWrap>
        {label}
      </Typography>
      {!value && (
        <Typography variant="body2" sx={{ fontFamily: 'monospace' }} noWrap>
          {displayValue}
        </Typography>
      )}
      {value && (
        <CopyableField
          variant="body2"
          sx={{
            alignItems: 'center',
            display: 'inline-flex',
            fontFamily: 'monospace',
            maxWidth: '100%',
            minWidth: 0,
            whiteSpace: 'nowrap',
            '& .MuiIconButton-root': {
              flexShrink: 0,
            },
          }}
          label={
            <Box component="span" sx={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {value}
            </Box>
          }
          value={value}
          tooltip={`Copy ${label}`}
        />
      )}
    </Stack>
  );
}
